import { render } from "./LandingComponent.vue?vue&type=template&id=3f41a582"
import script from "./LandingComponent.vue?vue&type=script&lang=js"
export * from "./LandingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__